/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";
import {
  fetchCourierAgents,
  fetchCourierOffice,
  resetCourier,
} from "../../../../redux/features/CourrierSlice";
import { useParams } from "react-router-dom";
import WhiteTitledCard from "../../../../components/cards/WhiteTitledCard";
import BranchTable from "./BranchTable";
import AgentTable from "./AgentsTable";
import Button from "../../../ui/Button";

const CourierCompanyTable = () => {
  const [activeTab, setActiveTab] = React.useState(1);
  const [openAddAgent, setOpenAddAgent] = useState(false);
  const [openAddBranch, setOpenAddBranch] = useState(false);
  const { courierOffices, agents } = useAppSelector((state) => state.courier);
  const { user } = useAppSelector((state) => state.auth);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const dispatch = useAppDispatch();
  const { id } = useParams();

  const tabList = [
    {
      id: 1,
      name: "Branches",
      count: courierOffices?.data?.totalItems ?? 0,
    },
    { id: 2, name: "Agents", count: agents?.data?.meta?.totalItems ?? 0 },
  ];

  useEffect(() => {
    dispatch(resetCourier());
    dispatch(fetchCourierOffice({ courierId: id, page: page + 1, limit }));
    dispatch(fetchCourierAgents({ courierId: id, page: page + 1, limit }));
  }, [id, page, limit]);

  return (
    <WhiteTitledCard>
      <div className="px-6">
        <div className="flex-col-reverse sm:flex-row flex sm:items-center sm:justify-between mb-4 gap-2">
          <div className="flex space-x-4 items-center">
            {tabList?.map((tab) => (
              <div
                key={tab.id}
                className={`space-x-2 cursor-pointer text-sm font-semibold p-2 ${
                  activeTab === tab.id
                    ? "text-black border-b-2 border-primary"
                    : ""
                }`}
                onClick={() => {
                  setActiveTab(tab.id);
                  setPage(0);
                  setLimit(10);
                }}
              >
                <span>{tab.name}</span>
                {
                  <span
                    className={"bg-lightPurple px-2  text-accent rounded-md"}
                  >
                    {tab?.count}
                  </span>
                }
              </div>
            ))}
          </div>
          {user?.user?.roles !== "INVESTOR" && (
            <div className="items-center gap-4 flex">
              {activeTab === 1 ? (
                <Button
                  layout="toolbar" size="sm"
                  label="Add branch"
                  onClick={() => setOpenAddBranch(true)}
                />
              ) : (
                <Button
                  layout="toolbar" size="sm"
                  label="Add agent"
                  onClick={() => setOpenAddAgent(true)}
                />
              )}
            </div>
          )}
        </div>
      </div>
      {activeTab === 1 && (
        <BranchTable
          page={page}
          setPage={setPage}
          setLimit={setLimit}
          openAddBranch={openAddBranch}
          setOpenAddBranch={setOpenAddBranch}
          onUpdate={() =>
            dispatch(
              fetchCourierOffice({ courierId: id, page: page + 1, limit })
            )
          }
        />
      )}
      {activeTab === 2 && (
        <AgentTable
          page={page}
          setPage={setPage}
          setLimit={setLimit}
          openAddAgent={openAddAgent}
          setOpenAddAgent={setOpenAddAgent}
          onUpdate={() =>
            dispatch(
              fetchCourierAgents({ courierId: id, page: page + 1, limit })
            )
          }
        />
      )}
    </WhiteTitledCard>
  );
};

export default CourierCompanyTable;
